'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedButton = void 0;
const $ = require("jquery");
class FixedButton {
    constructor() {
        let scroll = 0;
        $(window).on('scroll', function () {
            if ($(this).scrollTop() < scroll) {
                //上スクロールの時の処理
                $('.bulletFixedButton').attr('data-scroll-up', 'true');
            }
            else {
                //下スクロールの時の処理
                $('.bulletFixedButton').attr('data-scroll-up', 'false');
            }
            scroll = $(this).scrollTop();
        });
    }
}
exports.FixedButton = FixedButton;
exports.default = FixedButton;
